export default {
  discount_types: {
    cashback: 'Puncte de fidelitate',
    promo_code: 'Cod promoțional',
  },
  input: {
    label: '{{cashbackLabel}} sau {{promoCodeLabel}}',
    placeholder: 'Cod promoțional',
  },
  buttons: {
    apply: 'Aplică',
    remove: 'Elimină',
  },
  feedback: {
    login:
      '<highlight>Conectează-te</highlight> pentru a folosi această promoție și a verifica că nu ai folosit-o deja. Conectează-te și încearcă din nou.',
    usage_threshold: 'Suma minimă a coșului pentru această promoție este (excl. costurile de livrare)',
    promo_code_added: 'Cod promoțional aplicat cu succes',
  },
};
